import { render, staticRenderFns } from "./UberOrderDetailsModal.vue?vue&type=template&id=98b257de&scoped=true"
import script from "./UberOrderDetailsModal.vue?vue&type=script&lang=js"
export * from "./UberOrderDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./UberOrderDetailsModal.vue?vue&type=style&index=0&id=98b257de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b257de",
  null
  
)

export default component.exports